import React, { useEffect } from "react"

import styles from "./Raw.module.scss"

// A surpisingly convoluted component to display raw html data, such as script tags and the like :)

const Raw = ({ html, disableMinHeight }) => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.document) {
      let htmlParsed = new DOMParser().parseFromString(html, "text/html")
      let scriptElements = htmlParsed.getElementsByTagName("script")

      let arrayScriptSources = [].map
        .call(scriptElements, function (el) {
          return el.src
        })
        .filter((item) => {
          return item
        })

      if (arrayScriptSources.length > 0) {
        arrayScriptSources.forEach((item, i) => {
          const script = document.createElement("script")
          script.src = item
          script.async = true
          document.body.appendChild(script)
        })
      }

      let arrayScriptContents = [].map
        .call(scriptElements, function (el) {
          return el.textContent
        })
        .filter((item) => {
          return item
        })

      if (arrayScriptContents.length > 0) {
        arrayScriptContents.forEach((item, i) => {
          const script = document.createElement("script")
          script.textContent = item
          document.body.appendChild(script)
        })
      }
    }
  }, [html])

  return (
    <section
      className={`${styles.element} ${
        disableMinHeight ? styles.disableMinHeight : ""
      } `}
      dangerouslySetInnerHTML={{ __html: html }}
    ></section>
  )
}

export default Raw
